import { FC } from 'react';
import { Container } from '@/components';
import { useTranslation } from 'react-i18next';
import styles from './DocumentsHistoryPage.module.scss';
import DocumentsHistory from '../DocumentsHistory';

const DocumentsHistoryPage: FC = () => {
  const { t } = useTranslation('documentsHistory');
  return (
    <Container title={t('title')} className={styles.container}>
      <DocumentsHistory />
    </Container>
  );
};

export default DocumentsHistoryPage;
